var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-tag",class:`${_vm.type} ${_vm.size}`,style:(_vm.tagStyle)},[_c('span',{style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }